var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1592_75890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.799805,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1592_75890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4998 19.9248L20.4998 17.9248V7.79976H16.4498L14.6248 5.79976H10.3748L9.4248 6.84976L7.9998 5.42476L9.4998 3.79976H15.4998L17.3498 5.79976H20.4998C21.0498 5.79976 21.5206 5.99559 21.9123 6.38726C22.304 6.77892 22.4998 7.24976 22.4998 7.79976V19.9248ZM16.9748 14.3998L11.8998 9.32476C12.5998 9.24142 13.2831 9.30809 13.9498 9.52476C14.6165 9.74142 15.1998 10.0998 15.6998 10.5998C16.1998 11.0998 16.5581 11.6831 16.7748 12.3498C16.9915 13.0164 17.0581 13.6998 16.9748 14.3998ZM5.5248 5.79976L7.5248 7.79976H4.4998V19.7998H16.6748L1.1748 4.29976L2.5998 2.87476L22.3998 22.6748L20.9748 24.0998L18.6748 21.7998H4.4998C3.9498 21.7998 3.47897 21.6039 3.0873 21.2123C2.69564 20.8206 2.4998 20.3498 2.4998 19.7998V7.79976C2.4998 7.24976 2.69564 6.77892 3.0873 6.38726C3.47897 5.99559 3.9498 5.79976 4.4998 5.79976H5.5248ZM9.1498 10.8248L10.5498 12.2248C10.3665 12.4581 10.229 12.7081 10.1373 12.9748C10.0456 13.2414 9.9998 13.5164 9.9998 13.7998C9.9998 14.4998 10.2415 15.0914 10.7248 15.5748C11.2081 16.0581 11.7998 16.2998 12.4998 16.2998C12.7831 16.2998 13.0581 16.2539 13.3248 16.1623C13.5915 16.0706 13.8415 15.9331 14.0748 15.7498L15.4748 17.1748C15.0581 17.5414 14.5956 17.8206 14.0873 18.0123C13.579 18.2039 13.0498 18.2998 12.4998 18.2998C11.2498 18.2998 10.1873 17.8623 9.3123 16.9873C8.4373 16.1123 7.9998 15.0498 7.9998 13.7998C7.9998 13.2498 8.0998 12.7206 8.2998 12.2123C8.4998 11.7039 8.78314 11.2414 9.1498 10.8248Z",
    fill: "#BDBDBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20);
export default __webpack_public_path__ + "static/media/icon-20.3ea6e7623f4cd71fb76aed056bb9dacd.svg";
export { ForwardRef as ReactComponent };